import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipFormatterContextObject } from 'highcharts';
import AreaChart from '../../../../../components/common/atoms/AreaChart';
import Styles from './index.module.scss';
import { checkPrivileges, getSelectedFilterRange, getTooltipDateFormat } from '../../../../../utils';

type GraphPropsType = {
	data: Array<any>;
	total?: string;
	series: Array<{
		name: string;
		data: Array<number>;
		color: string;
	}>;
	filter: { [key: string]: any };
	selectedFilter: string;
};

const Graph: React.FC<GraphPropsType> = ({ data = [], total, series, filter, selectedFilter }) => {
	const { t } = useTranslation();

	// const maximum = data.reduce((acc: any, val: any) => {
	// 	return acc.total > val.total ? acc : val;
	// });

	const getTotal = (dataPointTotal: number) => {
		if (typeof dataPointTotal === 'number') {
			return dataPointTotal;
		}
		return total || 0;
	};

	const formatToolTip = (ctx: TooltipFormatterContextObject) => {
		const { x, points = [] } = ctx;
		const dataPoint = data.find(({ label }) => label === (x as unknown));
		const formattedDate = getTooltipDateFormat(selectedFilter, x);
		const title = `<p>${formattedDate}</p>`;
		const legendsLine = points
			.map(
				({ color, y, series: seriesVal }) => `<div class=${Styles.tooltipLine}>
            <div class=${Styles.legendsTitle}>
              <span style="color: ${color}">\u25CF</span>
              <span>${seriesVal?.name}</span>
            </div>
            <span>${y}</span>
          </div>`
			)
			.join('');
		const pointsString = `<div class=${Styles.legendsContainer}>
       ${legendsLine}
    </div>`;
		// contains hardcoded values.
		const extraInfoString = 
		
	`<div class=${Styles.legendsContainer}>
      <div class=${Styles.tooltipLine}>
        <span>${t('mainTotal')}</span>
        <span>${getTotal(dataPoint?.total)}</span>
      </div>
	  <div class=${Styles.tooltipLine}>
        <span>${t('mainCreditSpent')}</span>
        <span>${dataPoint?.usage}</span>
      </div>
	</div>`;

	    const withoutPricing =`<div class=${Styles.legendsContainer}>
      <div class=${Styles.tooltipLine}>
        <span>${t('mainTotal')}</span>
        <span>${getTotal(dataPoint?.total)}</span>
      </div>
	</div>`

		return `
		  <div class=${Styles.tooltipFormat}>
		    ${title}
		    ${checkPrivileges('prices','main') ? extraInfoString : withoutPricing}
		    ${pointsString}
		  </div>
		  `;
	};

	return (
		<AreaChart
			series={series.map((item) => ({ ...item, showInLegend: false }))}
			options={{
				title: {
					text: undefined,
				},
				yAxis: {
					labels: {
						enabled: false,
					},
					title: undefined,
					gridLineColor: 'transparent',
					margin: 0,
					// plotLines: [{
					// 	color: '#D7DCE0',
					// 	width: 2,
					// 	value: maximum.total,
					// 	dashStyle: 'Dash',
					// 	label: {
					// 		text: `${maximum.total}`,
					// 		style: {
					// 			color: '#8D9DB0',
					// 			fontWeight: '400',
					// 		}
					// 	},

					// }]
				},
				xAxis: {
					visible: true,
					categories: data.map(({ label }) => label),

					labels: {
						step: Math.floor(data.length / 6),
						formatter: function () {
							var label = this.axis.defaultLabelFormatter.call(this);
							return getSelectedFilterRange(selectedFilter, +label)
						}

					}
				},
				legend: {
					enabled: false,
				},
				tooltip: {
					shared: true,
					outside: true,
					borderWidth: 0,
					backgroundColor: '#FFFFFF',
					padding: 16,
					className: Styles.tooltipFormat,
					hideDelay: 0,
					useHTML: true,
					positioner: function (labelWidth, labelHeight, point) {
						let left = this.chart.pointer.getChartPosition().left;
						var tooltipX = left + point.plotX - (labelWidth / 2);
						var tooltipY = point.plotY + 25;
						return {
							x: tooltipX,
							y: tooltipY
						};
					},
					formatter() {
						return formatToolTip(this);
					},
				}
			}}
		/>
	);
};

export default Graph;
